import React, { Component } from "react";
import injectSheet from "react-jss";
import Color from "color";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { flexUtils, palette } from "../../../Theme/Theme";
import * as Actions from "../../../Actions/Actions";
import { CSSTransitionGroup } from "react-transition-group"; // ES6
import { Link } from "react-router-dom";
import PlaylistRow from "./PlaylistRow";
import Playlist from "./PlayList";
import styled, {keyframes} from "styled-components";
import { isMobile } from "react-device-detect";
import * as TempActions from "../../../Actions/TempPlaylistActions";
import AddNewPlaylist from './AddNewPlaylist'

const FadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const Container = styled.div`
  animation: ${FadeIn} 0.7s linear;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: 95vh;
  width: 100vw;
`;

const PlaylistContiner = styled.div`
  overflow-y: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  margin-top: 10vh;
  min-height: 90vh;
  transition: all 0.7s;
  opacity: ${props => (props.opacity ? props.opacity : "1")};
  &:> {
    border: 1px solid red;
  }
`;

class Playlists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHeroShown: true,
      opacity: 1,
      playlistID: "",
      playlistOpacity: 0,
      isPlaylistShown: false,
      chosenTitle: ""
    };
    this.playShow = this.playShow.bind(this);
  }
  render() {  
    // if (this.props.history[this.props.history.length -2] === this.props.history[this.props.history.length -1]) {
    //   this.state.opacity = 1
    //   this.state.playlistOpacity = 0
    // }
    const { playlistState } = this.props;
    return (
      <Container>
        {playlistState.pending ? this.loading() : this.Playlists()}
      </Container>
    );
  }

  componentWillUnmount () {
  }

  playShow(isResumed) {
    if (isMobile) {
      this.props.history.push("/Home/Mobile");
      return;
    }
    if (isResumed) {
      this.props.dispatch(Actions.ChooseShow(this.props.content));
    } else {
      this.props.content.progress = 0;
      this.props.dispatch(Actions.ChooseShow(this.props.content));
    }
    this.props.history.push("/Home/Show");
  }

  loading() {
    return <div>Loading Playlists...</div>;
  }

  Playlists() {
    const { playlists } = this.props;
    return (
      <PlaylistContiner opacity={this.state.opacity}>
        {playlists.map((view, index) => {          
          return (
            <PlaylistRow              
              // hideDiv={this.hideDiv}
              index={index}
              rowNum={index}
              view={view}
              key={index}
            />
          );
        })}
        <AddNewPlaylist/>
      </PlaylistContiner>
    );
  }

  showDiv = () => {
    this.setState({ opacity: "1", playlistOpacity: "0" });
    setTimeout(() => {
      this.setState({ isPlaylistShown: false, chosenTitle: "" });
    }, 100);
  };

  hideDiv = (playlistID, title) => {
    this.props.dispatch(TempActions.resetFirstMove());
    this.props.dispatch(
      Actions.getPlaylistContents(this.props.user.token, playlistID)
    );
    this.setState({ opacity: "0", chosenTitle: title, playlistID: playlistID });
    setTimeout(() => {
      this.setState({ isPlaylistShown: true, playlistOpacity: 1 });
    }, 0);
  };

  componentDidMount() {
    this.props.dispatch({ type: "RESET_SHOW_COUNT" });
    this.props.dispatch(Actions.getPlaylists(this.props.user.token));
    if (this.props.match.params.title !== undefined) {
      while (this.props.playlists[0].title === undefined) {}
      for (let i = 0; i < this.props.playlists.length; i++) {        
        if (this.props.playlists[i].title === this.props.match.params.title) {
          // console.log(this.props.playlists[i].title)
          this.hideDiv(this.props.playlists[i].id, this.props.playlists[i].title )
        }        
      }
    }
  }
}

const mapStateToProps = state => {
  return {
    user: state.mainState.user,
    playlistState: state.mainState.playlistState,
    playlists: state.mainState.playlists
  };
};

export default withRouter(connect(mapStateToProps)(Playlists));



// WEBPACK FOOTER //
// ./src/js/Components/Home/Playlists/Playlists.jsx